import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';

const Tooltip = ({ label, content }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  return (
    <span className="relative inline-block">
      <span 
        onMouseEnter={() => setIsVisible(true)} 
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
        className="cursor-help border-b border-brand-accent/60 hover:border-brand-accent text-brand-textHeading transition-colors font-medium whitespace-nowrap"
      >
        {label}
      </span>
      <AnimatePresence>
        {isVisible && (
          <motion.span 
            initial={{ opacity: 0, y: 5, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 5, scale: 0.95 }}
            transition={{ duration: 0.15 }}
            className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-3 w-[calc(100vw-3rem)] sm:w-80 p-5 bg-brand-card border border-brand-border rounded-xl shadow-2xl text-sm leading-relaxed text-brand-text pointer-events-none"
          >
            {content}
            <span className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-8 border-transparent border-t-brand-card"></span>
          </motion.span>
        )}
      </AnimatePresence>
    </span>
  );
};

const About = () => {
  const { t } = useLanguage();

  const renderParagraph = (text, index) => {
    if (text.includes('{{cp}}')) {
      const parts = text.split('{{cp}}');
      return (
        <p key={index} className="text-brand-textHeading font-medium opacity-95">
          {parts[0]}
          <Tooltip label={t.about.cp_label} content={t.about.cp_tooltip} />
          {parts[1]}
        </p>
      );
    }
    return <p key={index}>{text}</p>;
  };

  return (
    <Section id="about" bg="bg-brand-darker border-y border-brand-border/30">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5">
          <SectionHeading className="!mb-6">{t.about.heading}</SectionHeading>
          <div className="w-16 h-1 bg-brand-accent rounded mt-6"></div>
        </div>
        <div className="lg:col-span-7 space-y-6 text-lg text-brand-text leading-relaxed">
          {t.about.body.map((paragraph, index) => renderParagraph(paragraph, index))}
        </div>
      </div>
    </Section>
  );
};

export default About;